// Curated short words from Tanach (3–5 letters each), for the Hebrew Studio's
// "Inspire me" button. Hand-picked to be recognisable and evocative.

export const TANACH_WORDS = [
  "שלום", "אהבה", "חיים", "אור", "רוח", "נפש", "תורה",
  "אמת", "חסד", "ברכה", "צדק", "יום", "ליל", "שמש",
  "ירח", "כוכב", "ארץ", "שמים", "פרי", "מים",
  "אדם", "מלך", "נביא", "חכם",
  "צדיק", "עדן", "דרך", "חכמה", "בינה", "דעת", "שיר",
  "זמר", "קדש", "גאל", "אחד", "בית", "עיר",
  "שדה", "מטר", "ענן", "רעם", "כבוד", "תקוה", "אמן",
  "טוב", "רחל", "לאה", "משה", "דוד", "רות",
];

// Each Hebrew letter on the staff currently corresponds to a 30-letter
// "musical letter" cap on the English side. Hebrew text is denser per
// character; we keep the same per-letter cap so the staff doesn't overflow.
const DEFAULT_COUNT = 5;
const DEFAULT_MAX_LETTERS = 22;

export function pickRandomHebrewPhrase(count = DEFAULT_COUNT, maxLetters = DEFAULT_MAX_LETTERS) {
  const pool = [...new Set(TANACH_WORDS)];
  for (let i = pool.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [pool[i], pool[j]] = [pool[j], pool[i]];
  }
  const picked = [];
  let total = 0;
  for (const w of pool) {
    if (picked.length >= count) break;
    const len = [...w].length;
    if (total + len <= maxLetters) {
      picked.push(w);
      total += len;
    }
  }
  return picked.join(" ");
}
